<template>    
  <v-card class="ma-4 pa-4">
    <v-card-title class="text-h5">Descargador de precios</v-card-title>
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>
    <v-card-text>

      <v-row>


        <v-col cols="12">


        <v-row align="center" class="mb-4">
          <v-col cols="2">
            <VueDatePicker 
                  model-type="dd/MM/yyyy" 
                  v-model="fecha_inicio" 
                  :format="'dd/MM/yyyy'" text-input             
                  :teleport="true"
                   :auto-apply="true"                
                  />
          </v-col>
          <v-col cols="2">
              <VueDatePicker 
                  model-type="dd/MM/yyyy" 
                  v-model="fecha_fin" 
                  :format="'dd/MM/yyyy'" text-input             
                  :teleport="true"  
                   :auto-apply="true"              
                  />
          </v-col>
          <v-col cols="6">
            <v-btn  class="mr-3" @click="descargar_datos()">
               <span class="material-symbols-outlined">
              south_west
              </span>
              Descargar</v-btn>
            <v-btn  class="mr-3" @click="exportToCSV()">
               <span class="material-symbols-outlined">csv</span> 
              Exportar</v-btn>
              <v-btn  @click="exportToCSVQH()">
               <span class="material-symbols-outlined">csv</span> 
              Exportar QH</v-btn>
          </v-col>
        </v-row>

         <v-tabs
          v-model="tab1"
          color="primary"

          style="order: 2; "
          slider-color="primary"
        >
    <!-- {{$t('tabs.demanda')}} -->
      <v-tab value="1" class="tab-hover-azul" > Precios Horarios</v-tab>
      <v-tab value="2" class="tab-hover-azul">Precios Cuarto Horario</v-tab>
    </v-tabs>
  
    <!-- Contenido de los tabs -->
    <v-tabs-window v-model="tab1" class="flex-grow-1 mt-3" style="order: 1; ">
  

      <!-- Precios Horarios -->
      <v-tabs-window-item value="1">
        <v-container class="pa-0" fluid>
           <v-row>
            <v-col cols="12">
              <div id="mi-clase-personalizada">
                <v-grid 
                  :disabled="false"
                  theme="material" 
                  :source="data" 
                  :columns="headers"
                  canFocus=true
                  range=true
                  useClipboard=true
                  filter=true
                  resize=true         
                  style="min-height: 65vh; max-width: 840px;"       
                  row-class="rowClass"

                ></v-grid>      
              </div>
            </v-col>      
          </v-row>
          </v-container>
          </v-tabs-window-item>
          <v-tabs-window-item value="2">
            <!-- Precios cuarto horario -->
        <v-container class="pa-0" fluid>
           <v-row>
            <v-col cols="12">
              <div id="mi-clase-personalizada">
                <v-grid 
                  :disabled="false"
                  theme="material" 
                  :source="data_QH" 
                  :columns="headers_QH"
                  canFocus=true
                  range=true
                  useClipboard=true
                  filter=true
                  resize=true         
                  style="min-height: 65vh; max-width: 840px;"       
                  row-class="rowClass"

                ></v-grid>      
              </div>
            </v-col>      
          </v-row>
          </v-container>
          </v-tabs-window-item>
          </v-tabs-window>
          
        
         
        
        </v-col>




      </v-row>


    </v-card-text>
  </v-card>
  <v-dialog v-model="showAlert" max-width="400">
      <v-card>
        <v-card-title class="headline">⚠️ Atención</v-card-title>
        <v-card-text>{{ error_msg }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showAlert = false; error_msg=''">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import VGrid from "@revolist/vue3-datagrid";
import ComponenteLoading from '../ComponenteLoading.vue';
import store from '../../store';
import axios from 'axios';

export default {
  components: {
    VGrid,
    ComponenteLoading,
  },
  data() {

    return {
        tab1:"1",
        loading: false,
        mensaje_loading: "",

        fecha_inicio: new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }),

        fecha_fin: new Date().toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }),

        data: [        
        ],
        data_QH:[],
        showAlert:false,
        error_msg:"",


      headers: [
        { prop: "fecha", name: "Fecha", size: 200,
     },
        { prop: "omie", name: "OMIE", size: 150 },
        { prop: "simulart", name: "SimularT", size: 150 },
        //{ prop: "mibgas", name: "MIBGAS", size: 150 },
        { prop: "mibgas_2", name: "MIBGAS", size: 100 },
        { prop: "co2", name: "CO2", size: 100 },
        { prop: "H2_IBHYX", name: "H2 IBHYX", size: 100 },
      ],

      headers_QH: [
        { prop: "fecha", name: "Fecha", size: 200,
        },
        { prop: "omie", name: "OMIE", size: 150 },
      ],



    };
  },

  watch: {

  },
  mounted() {
    
  },


  methods: {
     toCsvDecimalComma(v, fixed = 2) {
        if (v === null || v === undefined || v === '') return '';
        let n = Number(v);
        if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
        if (Number.isNaN(n)) return '';
        return n.toLocaleString('es-ES', {
            minimumFractionDigits: fixed,
            maximumFractionDigits: fixed,
            useGrouping: false, 
        });
        },
    convertirFecha(fecha) {
        let partes = fecha.split('/'); // Divide "DD/MM/YYYY" en ["DD", "MM", "YYYY"]
        return `${partes[2]}-${partes[1]}-${partes[0]}`; // Rearma en "YYYY-MM-DD"
    },
    async descargar_datos(){
      this.loading = true;
      console.log("This loading: ", this.loading)
      this.mensaje_loading = "Descargando datos en cuarto horario ..."
      await this.$nextTick()
      await this.obtener_datos_QH();
      this.mensaje_loading = "Descargando datos horarios ..."
      await   this.obtener_datos();
       this.loading = false;     
    },

   obtener_datos_QH(){

       let fecha_inicio_api = this.convertirFecha(this.fecha_inicio)
        let fecha_fin_api =  this.convertirFecha(this.fecha_fin)

          

           return axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/descargador-precios-QH?start_date=' + fecha_inicio_api + '&end_date=' + fecha_fin_api,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {                  
              let myObject = response.data;
              this.data_QH = this.data_QH = myObject.map(item => ({
                ...item,
                rowClass: "ClaseRow"
              }));              
                   
              console.log("Response: ",response)
              return response
             
          })
          

    },

     obtener_datos(){
                
        let fecha_inicio_api = this.convertirFecha(this.fecha_inicio)
        let fecha_fin_api =  this.convertirFecha(this.fecha_fin)

          
          return axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/descargador-precios?start_date=' + fecha_inicio_api + '&end_date=' + fecha_fin_api,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {                  
              let myObject = response.data;
              this.data = this.data = myObject.map(item => ({
                ...item,
                rowClass: "ClaseRow"
              }));              
                
          })


          
      },

      exportToCSVQH(){
        if(this.data_QH.length>0){
          console.log(this.data_QH)
          const headers_QH = this.headers_QH.map((col) => col.name).join(";");
        
            const rows = this.data_QH.map((row) =>
            this.headers_QH.map((col) => {
              return row[col.prop] === undefined || row[col.prop] === null ? "" : row[col.prop];
            }).join(";")
          ); 

          const csvContent = [headers_QH, ...rows].join("\n");
                // Crear un BOM para UTF-8 y forzar que se vea el simbolo €
            const BOM = "\uFEFF";
            const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "precios_QH.csv";
            a.click();
            URL.revokeObjectURL(url);
        }
        else{
          console.log("Datos vacíos")
          this.error_msg="Descarga los precios antes de exportarlos";
          this.showAlert=true;
          
        }
      
      },
      exportToCSV(){
        
        if(this.data.length>0){
          console.log(this.data)
          const headers = this.headers.map((col) => col.name).join(";");
        
            const rows = this.data.map((row) =>
            this.headers.map((col) => {
              return row[col.prop] === undefined || row[col.prop] === null ? "" : row[col.prop];
            }).join(";")
          ); 

          const csvContent = [headers, ...rows].join("\n");
                // Crear un BOM para UTF-8 y forzar que se vea el simbolo €
            const BOM = "\uFEFF";
            const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "precios.csv";
            a.click();
            URL.revokeObjectURL(url);
        }
        else{
          console.log("Datos vacíos")
          this.error_msg="Descarga los precios antes de exportarlos";
          this.showAlert=true;
          
        }
      }



  },
  created() {
    
  }
};
</script>



<style scoped>

/* ::v-deep(.formato_fecha){
   font-weight: bold !important;
   justify-content: center;
} */
/* ::v-deep(.mi-clase-personalizada)  {
    border-radius: 4px !important;
} */
 /* Estilo hover, similar a las otras tablas sin v-grid */
::v-deep(.ClaseRow:hover){
    background-color: #e6f2f6 !important; 
  border-left: 2px solid #1776BF !important;
}

/* Estilo para las cabeceras, similar a las tablas sin v-grid */
::v-deep(.rgHeaderCell) {
     background-color: #f2f2f2 !important;
    color: #282828 !important;
    padding: 5px !important;
    min-width: 100px !important;
     font-weight: bold;
     text-align: center !important;
    
    
}
/* Estilo redondeado para la tabla, similar a las tablas sin v-grid */
#mi-clase-personalizada ::v-deep(.main-viewport) {
  border-radius: 20px;
  overflow: hidden; /* importante para que no se vean las esquinas cuadradas internas */
 
}
/* Estilo para la columna de Fecha, similar a las tablas sin v-grid */
::v-deep([data-rgcol="0"]) {
  font-weight: bold !important;
}


</style>
